export enum FitnessPlanType {
  GYM = 1,
  DIET = 2,
  CROSSFIT = 3,
  HYBRID = 4,
  PT = 5,
  CARDIO = 6,
  OTHERS = 7,
  ADMIN = 8
}

export enum FitnessGoalType {
  WEIGHTLOSS = 1,
  WEIGHTGAIN = 2,
  MUSCLEGAIN = 3,
  ATHLETICS = 4,
  PROFESSIONAL = 5
}

export enum DietType {
  VEG = 1,
  NONVEG = 2,
  VEGAN = 3,
  EGGITARIAN = 4
}

export enum MeasurementUnit {
  NONE = 0,
  GRAMS = 1,
  KGS = 2,
  LBS = 3,
  MILLIMETERS = 4,
  CMS = 5,
  INCH = 6,
  FT = 7,
  KMS = 8,
  MINUTE = 9,
  HOUR = 10,
  PERCENTAGE = 11,
  COUNT = 12,
  ML = 13,
  LTR = 14,
  GALLON = 15,
  OUNCE = 16
}

export enum PricingModel {
  FIXED = 1,
  PERDAY = 2,
  PERMONTH = 3,
  YEARLY = 4
}

export enum PhotoIdType {
  DL = 1,
  AADHAR = 2,
  PAN = 3
}
